module.exports = __webpack_public_path__ + "static/media/media.3aba0da3.png";